import React from 'react';
import Card from '../components/Card';

export default function PartnerPage() {
  return (
    <div className="partner-layout">
      <div style={{ maxWidth: 520, margin: '60px auto' }}>
        <Card>
          <h2 style={{ marginBottom: '8px', fontSize: '1.1rem' }}>Партнёрский раздел</h2>
          <p className="text-muted text-sm" style={{ marginBottom: 16 }}>
            Партнёрский кабинет доступен на отдельной странице.
          </p>
          <a
            href="https://id.sbpusdt.ru/login"
            className="btn btn-primary btn-md"
            style={{ textDecoration: 'none' }}
            target="_blank"
            rel="noopener noreferrer"
          >
            Войти в партнёрский кабинет
          </a>
        </Card>
      </div>
    </div>
  );
}
